import React, { Fragment, useState, useRef, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import Modal from '../../common/Modal';
import Button from "../../Button";
import styles from '../Forms/StudentImport/StudentImport.module.sass'
import CreatableSelect from 'react-select/creatable';

const CreateStudents = ({ schoolId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [seasons, setSeasons] = useState([])
  const [formData, setFormData] = useState()
  const form = useRef(null)

  useEffect(() => {
    fetch(`/admin/schools/${schoolId}/seasons`,
      { method: 'GET' })
      .then(res => res.json())
      .then(json => {
        const seasons = json.map((season) => ({ value: season, label: season }))
        setSeasons(seasons);
      })
  }, [schoolId])

  const openModal = () => setIsOpen(true);
  const closeModal = () => {
    setSeasons([])
    setIsOpen(false)
    setIsSubmitting(false)
    setFormData()
  };
  const { register, handleSubmit, control, setValue } = useForm();

  const onSubmit = () => {
    setIsSubmitting(true)

    const formData = new FormData(form.current)

    formData.append('school_id', schoolId)
    fetch('/admin/students/generate_students',
      { method: 'POST', body: formData })
      .then(() => {
        toast('Students are now generating in the background.',
          { type: 'success' });
        closeModal();
      })
  }

  const renderForm = () => {
    return (
      <form ref={form} onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <label className={styles.label}>
            <span>
              Number of Students
            </span>

          <input
            {...register("number_of_students", { required: true, message: "Please specify the number of students" })}
            className={styles.numberInput}
            type="number" />
        </label>

        <Controller
          control={control}
          name="season"
          render={({ field, value }) => (
            <CreatableSelect
              {...field}
              isClearable
              onChange={(e) => setValue('season', e)}
              options={seasons}
              placeholder="Select season (type to create a new season)"
            />
          )}
        />

        <div className={styles.formActions}>
          <Button
            fullWidth
            variant='primary'
            disabled={isSubmitting}
          >
            Continue
          </Button>
        </div>
      </form>
    )
  }

  return (
    <Fragment>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Create students"
        headerText="Create students"
      >
        {renderForm()}
      </Modal>

      <Button onClick={openModal}>
        Create Students
      </Button>
    </Fragment>
  )
}

export default CreateStudents;
